<!--suppress JSUnresolvedVariable -->
<template>
  <div class="game-list bg-light pb-5">
    <div
      class="top jumbotron jumbotron-fluid mb-2"
      :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
    >
      <div class="container text-danger">
        <h1 class="animated fadeInDown">游戏中心</h1>
        <p class="animated fadeInDown">—— {{ sectionSubTitle }} ——</p>
      </div>
    </div>
    <div class="container content mt-5">
      <!-- 面包屑导航 -->
      <div class="text-right position mb-3 d-none d-md-block text-muted">
        当前位置：
        <router-link to="/toHome" class="text-muted">首页</router-link>
        /
        <a href="#" class="text-muted">游戏中心</a>
      </div>

      <div class="row" v-if="logSys === 1">
        <div
          class="col-12 col-sm-6 col-lg-3 my-3 animated zoomIn"
          v-for="(item, index) in gameList"
          :key="index"
        >
          <el-card
            :body-style="{ padding: '0px' }"
            class="el-card border-0"
            shadow="hover"
          >
            <a href="#"><img :src="item.gameImg" alt="图片" class="w-100"/></a>
            <div style="padding: 14px;">
              <a href="#">
                <span class="font-weight-bold">{{ item.gameName }}</span>
              </a>
              <p class="bottom mt-2">
                <a href="#">
                  <span
                    class="badge badge-danger badge-pill"
                    v-if="item.gameTag === 1"
                    >hot</span
                  >
                  <span
                    class="badge badge-success badge-pill"
                    v-if="item.gameTag === 2"
                    >推荐</span
                  >
                  <span
                    class="badge badge-info badge-pill"
                    v-if="item.gameTag === 3"
                    >新上</span
                  >
                  {{ item.gameProfile }}
                </a>
              </p>
              <div class="text-center download-btn">
                <a
                  class="btn btn-success text-white btn-sm btn-block"
                  @click="downloadAndroid(item.gameId, item.androidUrl)"
                  v-if="isPC || isAndroid"
                >
                  <i class="fa fa-android" aria-hidden="true"></i>
                  安卓下载
                </a>
                <a
                  class="btn btn-danger text-white btn-sm btn-block mt-3"
                  @click="downloadIOS(item.gameId, item.iosUrl)"
                  v-if="isPC || isIOS"
                >
                  <i class="fa fa-apple" aria-hidden="true"></i>
                  IOS下载
                </a>
              </div>
            </div>
          </el-card>
        </div>
      </div>

      <!-- 小屏显示 -->
      <div class="phone-game-list" v-else>
        <div
          class="my-2 bg-white list-item row no-gutters"
          v-for="(item, index) in gameList"
          :key="index"
        >
          <div class="cover">
            <img :src="item.gameIcon" class="w-100 h-100" alt="封面" />
          </div>
          <div class="info col-6">
            <div class="game-name font-weight-bold">
              {{ item.gameName }}
              <span
                class="badge badge-danger badge-pill"
                v-if="item.gameTag === 1"
                >hot</span
              >
              <span
                class="badge badge-success badge-pill"
                v-if="item.gameTag === 2"
                >推荐</span
              >
              <span
                class="badge badge-info badge-pill"
                v-if="item.gameTag === 3"
                >新上</span
              >
            </div>
            <div class="game-info">{{ item.gameProfile }}</div>
          </div>
          <div class="button-div flex-fill">
            <button
              class="btn btn-outline-success"
              @click="downloadAndroid(item.gameId, item.androidUrl)"
              v-if="isPC || isAndroid"
            >
              免费下载
            </button>
            <button
              class="btn btn-outline-danger"
              @click="downloadIOS(item.gameId, item.iosUrl)"
              v-if="isPC || isIOS"
            >
              免费下载
            </button>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="text-center mt-4">
        <a
          type="danger"
          @click="findMore()"
          class="btn text-danger font-weight-bold"
          v-if="this.total !== this.gameList.length"
        >
          <img :src="moreImgUrl" alt="logo" width="40" class="rounded-circle" />
          加载更多
        </a>
        <el-divider v-if="this.total === this.gameList.length">
          <small class="text-muted">我可是有底线的</small>
        </el-divider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GameList",
  data() {
    return {
      isPC: false,
      isAndroid: false,
      isIOS: false,
      sectionSubTitle: "",
      moreImgUrl: "",
      logSys: 1,
      backgroundUrl: "",
      currentPage: 1,
      pageSize: 8,
      total: 0,
      gameList: []
    };
  },
  mounted() {
    this.isSystem();
    this.getNavById();
    this.getALlGame();
  },
  methods: {
    downloadAndroid(gameId, androidUrl) {
      if (this.isWeiXin()) {
        alert("请使用浏览器打开网站下载！");
        return;
      }
      this.axios
        .put("/game/androidDownloads/" + gameId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            window.location.href = androidUrl;
          }
        })
        .catch();
    },
    downloadIOS(gameId, iosUrl) {
      if (this.isWeiXin()) {
        alert("请使用浏览器打开网站下载！");
        return;
      }
      this.axios
        .put("/game/iosDownloads/" + gameId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (this.logSys === 1) {
              window.open(iosUrl, "_blank"); // 新窗口打开外链接
            } else {
              window.location.href = iosUrl;
            }
          }
        })
        .catch();
    },
    isSystem() {
      if (navigator.userAgent.match("Android")) {
        this.isAndroid = true;
        this.logSys = 2;
      } else if (navigator.userAgent.match("iPhone")) {
        this.isIOS = true;
        this.logSys = 3;
      } else if (navigator.userAgent.match("iPad")) {
        this.isIOS = true;
        this.logSys = 3;
      } else {
        this.isPC = true;
        this.logSys = 1;
      }
    },

    isWeiXin() {
      if (navigator.userAgent.match("MicroMessenger")) {
        return true;
      }
      return false;
    },

    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 4)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.sectionSubTitle = resp.data.data.subTitle;
            this.moreImgUrl = resp.data.data.moreImgUrl;
            this.backgroundUrl = resp.data.data.bannerImg;
          }
        })
        .catch();
    },
    getALlGame() {
      this.axios
        .get("/game/getALlGame", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.gameList = this.gameList.concat(resp.data.data.records);
            this.total = resp.data.data.total;
            this.currentPage += 1;
          }
        })
        .catch();
    },
    findMore() {
      this.getALlGame();
    }
  }
};
</script>

<style scoped lang="scss">
.game-list {
  margin-top: 67px;

  .top {
    background: no-repeat center;
    width: 100%;
    background-size: cover;
  }

  .content {
    a {
      text-decoration: none;
      color: #333;
    }

    .row {
      div {
        .el-card {
          div {
            .bottom {
              height: 62px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }

            .download-btn {
              a {
                font-size: 24px;
              }

              @media only screen and (min-width: 576px) {
                a {
                  font-size: 14px;
                }
              }
            }
          }
        }

        .el-card:hover {
          box-shadow: 0 0 0.5rem rgba(220, 10, 25, 0.7);
          border-radius: 0;
        }
      }
    }

    .phone-game-list {
      .list-item {
        border-radius: 5px;
        padding: 10px 5px;
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        .cover {
          /*width: 25%;*/
          width: 72px;
          height: 72px;
          img {
            border-radius: 10px;
          }
        }
        .info {
          /*width: 60%;*/
          height: 72px;
          padding: 0 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          .badge {
            line-height: 1.5;
          }
          .game-info {
            font-size: 12px;
          }
        }

        .button-div {
          width: 51px;
          height: 72px;
          display: flex;
          justify-content: center;
          align-items: center;
          button {
            font-size: 12px;
          }
        }
      }
    }

    .el-divider__text {
      background-color: #f8f9fa;
    }
  }
}
</style>
